/*
* Configuration for Product
*/
export default function () {
  const { $i18n: i18n } = useNuxtApp()

  return {
    showBtnOnHeader: true,
    showProductLogoOnHeader: true,
    enableOrderMaxQuantity: true,
    widgets: [
      {
        widgetId: 'Breadcrumbs',
        widgetEnable: false,
        data: {
          parentClasses: 'bg-white py-6'
        }
      },
      {
        widgetId: 'ProductsHero',
        sectionId: 'hero',
        widgetEnable: true,
        data: {
          flex: ['s12 m12 l7', 's12 m12 l5'],
          parentClasses: 'bg-white',
          parentStyle: 'defaultStyle',
          actionBtns: {
            parentClasses: 'flex-row',
            customize: {
              enable: true,
              buttonTitle: i18n?.t('customizeNow'),
              parentClasses: 'w-full flex-1',
              buttonClasses: 'secondary-color base',
              showDescr: true
            },
            quote: {
              enable: false,
              buttonTitle: i18n?.t('quickQuote'),
              buttonClasses: 'btn-flat orange-border',
              buttonClassesSecond: 'btn-flat orange-border',
              showDescr: true
            },
            shortQuote: {
              enable: true,
              buttonTitle: i18n?.t('quickQuote'),
              parentClasses: 'w-full flex-1',
              buttonClasses: 'btn-flat orange-border',
              buttonClassesSecond: 'btn-flat orange-border',
              showDescr: true,
              options: {
                typeId: 'productQuote',
                componentId: 'FormsGroupConversationsProductQuote',
                header: i18n?.t('requestMyDesign'),
                buttons: {},
                steps: {
                  specifications: {
                    title: i18n?.t('selectYourProductFeatures'),
                    descr: i18n?.t('pleaseFillOutTheForm')
                  },
                  clientInfo: {
                    title: i18n?.t('personalInformation'),
                    descr: false
                  }
                }
              }
            },
            contactAdvisor: {
              enable: false,
              buttonTitle: i18n?.t('requestMyGiftDesign'),
              buttonClasses: 'btn-flat border-black uppercase',
              buttonClassesSecond: 'secondary-color base uppercase',
              showDescr: false
            }
          },
          reviewsEnable: true,
          mainInfoEnable: false,
          timeStripeEnable: true,
          advantagesEnable: true,
          priceEnable: true
        }
      },
      {
        widgetId: 'ProductsFeatures',
        sectionId: 'features',
        widgetEnable: true,
        data: {
          parentClasses: 'base-section sm',
          parentStyle: 'defaultStyle',
          showDimensions: true,
          showCertifications: true
        }
      },
      {
        widgetId: 'PagesGallery',
        sectionId: 'gallery',
        widgetEnable: true,
        data: {
          parentClasses: 'base-section sm grey lighten-3',
          parentStyle: 'defaultStyle'
        }
      },
      {
        widgetId: 'ProductsOverview',
        sectionId: 'overview',
        widgetEnable: true,
        data: {
          parentClasses: 'base-section sm grey lighten-3',
          parentStyle: 'defaultStyle'
        }
      },
      {
        widgetId: 'ProductsAccessories',
        sectionId: 'accessories',
        widgetEnable: true,
        data: {
          parentClasses: 'base-section sm',
          parentStyle: 'defaultStyle',
          slider: {
            breakpoints: {
              0: {
                slidesPerView: 1
              },
              480: {
                slidesPerView: 2
              },
              650: {
                slidesPerView: 3
              },
              993: {
                slidesPerView: 4
              }
            }
          }
        }
      },
      {
        widgetId: 'PagesReviewsAndClients',
        sectionId: 'review',
        widgetEnable: true,
        data: {
          parentClasses: 'base-section sm grey lighten-3',
          parentStyle: 'defaultStyle',
          label: i18n?.t('reviews'),
          title: i18n?.t('customersLoveUs'),
          titleSecond: i18n?.t('trustedByTheBest'),
          randomCount: 15,
          dynamics: true
        }
      },
      {
        widgetId: 'ProductsServices',
        sectionId: 'services',
        widgetEnable: true,
        data: {
          parentClasses: '',
          parentStyle: 'defaultStyle'
        }
      },
      {
        widgetId: 'ProductsRelatedProducts',
        sectionId: 'relatedProducts',
        widgetEnable: true,
        data: {
          parentClasses: 'base-section sm grey mt-8 lighten-3',
          parentStyle: 'defaultStyle',
          showMoreBtn: true,
          slider: {
            breakpoints: {
              0: {
                slidesPerView: 1
              },
              480: {
                slidesPerView: 1
              },
              650: {
                slidesPerView: 2
              },
              993: {
                slidesPerView: 3
              }
            }
          }
        }
      },
      {
        widgetId: 'PagesOurDifference',
        sectionId: 'ourDifference',
        widgetEnable: true,
        data: {
          parentClasses: 'base-section sm',
          parentStyle: 'defaultStyle',
          items: [
            {
              label: false,
              title: false,
              subTitle: false,
              descr: false,
              video: 'GXm4NX98Mp4',
              videoPreview: 'https://old.customusb.com/img/global/youtube.1601003964.jpg',
              classes: 'm6 s12'
            },
            {
              label: i18n?.t('widgets.PagesOurDifferenceProduct.items.0.label'),
              title: i18n?.t('widgets.PagesOurDifferenceProduct.items.0.title'),
              subTitle: false,
              descr: false,
              content: i18n?.t('widgets.PagesOurDifferenceProduct.items.0.content'),
              video: false,
              videoPreview: false,
              classes: 'm6 s12'
            }
          ]
        }
      },
      {
        widgetId: 'ProductsParallax',
        sectionId: 'parallax',
        widgetEnable: true,
        data: {
          parentClasses: 'parallax-container',
          parentStyle: 'defaultStyle',
          timeStripeEnable: true,
          actionBtns: {
            customize: {
              enable: true,
              buttonTitle: i18n?.t('customizeNow'),
              buttonClasses: 'secondary-color base',
              showDescr: true
            },
            quote: {
              enable: false,
              buttonTitle: i18n?.t('quickQuote'),
              buttonClasses: 'btn-flat white-border',
              buttonClassesSecond: 'btn-flat white-border',
              showDescr: true
            },
            shortQuote: {
              enable: true,
              buttonTitle: i18n?.t('quickQuote'),
              buttonClasses: 'btn-flat white-border',
              buttonClassesSecond: 'btn-flat white-border',
              showDescr: true,
              options: {
                typeId: 'productQuote',
                componentId: 'FormsGroupConversationsProductQuote',
                header: i18n?.t('requestMyDesign'),
                buttons: {},
                steps: {
                  specifications: {
                    title: i18n?.t('selectYourProductFeatures'),
                    descr: i18n?.t('pleaseFillOutTheForm')
                  },
                  clientInfo: {
                    title: i18n?.t('personalInformation'),
                    descr: false
                  }
                }
              }
            },
            contactAdvisor: {
              enable: false,
              buttonTitle: i18n?.t('contactUsToPurchase'),
              buttonClasses: 'btn-flat white-border uppercase',
              buttonClassesSecond: 'btn-flat white-border uppercase',
              showDescr: false
            }
          }
        }
      },
      {
        widgetId: 'ProductsConversation',
        sectionId: 'conversation',
        widgetEnable: true,
        data: {
          parentClasses: '',
          parentStyle: 'defaultStyle',
          id: 'conversationQuote',
          position: 'right',
          conversation: {
            enable: true
          },
          steps: {
            specifications: {
              title: i18n?.t('selectYourProductFeatures'),
              descr: i18n?.t('pleaseFillOutTheForm')
            },
            clientInfo: {
              title: false,
              descr: false
            }
          }
        }
      }
    ]
  }
}
